import { useNrefBootResolve } from '@hooks/useNrefBootResolve';

/**
 * Mounts the cold-start web-push destination resolver (N1 task W3): consumes
 * a service-worker-issued /notifications?nref= boot URL and replace-navigates
 * to the resolved destination. Web-only by mount site (RootLayout gates it
 * with !isNativePlatform(), beside WebPushInitializer) - native taps resolve
 * in usePushNotifications and never mint nref URLs.
 */
export const NrefBootResolver = (): null => {
  useNrefBootResolve();
  return null;
};
